import styles from './SideBar.module.css';
import SchoolLogo from '../../assets/images/schoolLogo.png';
import { RxDashboard } from 'react-icons/rx';
import { PiUsersThreeDuotone } from 'react-icons/pi';
import { FaUserCheck, FaWpforms } from 'react-icons/fa';
import SideBarMainLink from '../../components/SideBarMainLink/SideBarMainLink';
import { useEffect, useState } from 'react';
import { MdOutlineAssessment, MdOutlineTextSnippet } from 'react-icons/md';
import { LuCalendar, LuCalendarDays, LuMessagesSquare } from 'react-icons/lu';
import { TbLayoutSidebarLeftExpand, TbListDetails, TbMessage, TbReportAnalytics } from 'react-icons/tb';
import { useLocation } from 'react-router';

function SideBar() {
  const [expandedLabel, setExpandedLabel] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const matchedItem = sideBarMenuItems.find((item) =>
      item.subLinks?.some((sub) => location.pathname.startsWith(sub.toRoute))
    );

    if (matchedItem) {
      setExpandedLabel(matchedItem.label);
    } else {
      // Optionally collapse all if no match
      setExpandedLabel(null);
    }
  }, [location.pathname]);

  const sideBarMenuItems = [
    {
      label: "Dashboard",
      toRoute: "",
      icon: <RxDashboard size={20} />,
    },
    {
      label: "Management",
      icon: <PiUsersThreeDuotone size={24} />,
      subLinks: [
        { label: "Students", toRoute: "/management/students" },
        { label: "Staff", toRoute: "/management/staff" },
        { label: "Rooms", toRoute: "/management/rooms" },
        { label: "Groups", toRoute: "/management/groups" },
        { label: "Labels", toRoute: "/management/labels" },
        { label: "Email templates", toRoute: "/management/email-templates" },
      ],
    },
    {
      label: "Attendance",
      icon: <FaUserCheck size={20} />,
      subLinks: [
        { label: "Student Attendance", toRoute: "/attendance/students" },
        { label: "Staff Attendance", toRoute: "/attendance/staff" },
        { label: "Student Leaves", toRoute: "/attendance/studentleaves" },
        { label: "Staff Leaves", toRoute: "/attendance/staffleaves" },
        { label: "Ratio", toRoute: "/attendance/ratio" },
        { label: "Forecast", toRoute: "/attendance/forecast" },
      ],
    },
    {
      label: "Program",
      icon: <LuCalendarDays size={20} />,
      subLinks: [
        { label: "Program", toRoute: "/program/program" },
        { label: "Dashboard", toRoute: "/program/programdashboard" },
        { label: "Room Movement", toRoute: "/program/roommovement" },
      ],
    },
    {
      label: "Communication",
      icon: <LuMessagesSquare size={20} />,
      subLinks: [
        { label: "Activities", toRoute: "/communication/activities" },
        { label: "News Letters", toRoute: "/communication/newsletters" },
      ],
    },
    {
      label: "Enquiries",
      icon: <TbLayoutSidebarLeftExpand size={20} />,
      subLinks: [
        { label: "Dashboard", toRoute: "/enquiries/dashboard" },
        { label: "Enquiries", toRoute: "/enquiries/enquiriesscreen" },
        { label: "Tasks", toRoute: "/enquiries/tasks" },
        { label: "Enquiry Forms", toRoute: "/enquiries/enquiryforms" },
        { label: "Email Templates", toRoute: "/enquiries/emailtemplates" },
        {
          label: "Enquiry Automation",
          toRoute: "/enquiries/enquiryautomation",
        },
        { label: "Facebook Int", toRoute: "/enquiries/facebookint" },
      ],
    },
    {
      label: "Fee Plan",
      icon: <MdOutlineTextSnippet size={20} />,
      subLinks: [
        { label: "Fee Plan", toRoute: "/feeplan/feeplan" },
        { label: "Email Templates", toRoute: "/feeplan/feeemailtemplate" },
        { label: "Fee Component", toRoute: "/feeplan/feecomponent" },
        { label: "Fee Remainder", toRoute: "/feeplan/feeremainder" },
      ],
    },
    {
      label: "Accounting",
      icon: <TbListDetails size={20} />,
      subLinks: [
        { label: "Dashboard", toRoute: "/accounting/dashboard" },
        { label: "Student Balance", toRoute: "/accounting/studentbalance" },
        { label: "Invoices", toRoute: "/accounting/invoices" },
        { label: "Payments", toRoute: "/accounting/payments" },
        { label: "Debit Notes", toRoute: "/accounting/debitnotes" },
        { label: "Credit Balance", toRoute: "/accounting/creditbalance" },
        { label: "Deposits", toRoute: "/accounting/deposits" },
        { label: "Expenses", toRoute: "/accounting/expenses" },
        { label: "Upcoming Invoices", toRoute: "/accounting/upcominginvoices" },
        {
          label: "Email Template",
          toRoute: "/accounting/accountingemailtemplate",
        },
      ],
    },
    {
      label: "Messages",
      icon: <TbMessage size={20} />,
      subLinks: [
        { label: "Messaging", toRoute: "/messages/allmessaging" },
        { label: "Staff Messages", toRoute: "/messages/staffmessages" },
        { label: "Announcement", toRoute: "/messages/announcement" },
      ],
    },
    {
      label: "Calender",
      icon: <LuCalendar size={20} />,
      subLinks: [
        { label: "Staff Schedule", toRoute: "/calender/staffschedule" },
        { label: "Student Schedule", toRoute: "/calender/studentschedule" },
        { label: "Staff Holidays", toRoute: "/calender/staffholidays" },
        { label: "Birthdays", toRoute: "/calender/birthdays" },
        { label: "School Calender", toRoute: "/calender/schoolcalender" },
      ],
    },
    {
      label: "Assessments",
      icon: <MdOutlineAssessment size={20} />,
      subLinks: [
        { label: "Lessons", toRoute: "/assessments/lessons" },
        { label: "Records", toRoute: "/assessments/records" },
        { label: "Reports", toRoute: "/assessments/reports" },
        { label: "Assessments", toRoute: "/assessments/assessments" },
        { label: "Learning Journey", toRoute: "/assessments/learningjourney" },
        { label: "Manage", toRoute: "/assessments/manage" },
        { label: "Curriculam", toRoute: "/assessments/curriculam" },
        { label: "Assess.Reports", toRoute: "/assessments/assessreports" },
      ],
    },
    {
      label: "Forms",
      icon: <FaWpforms size={20} />,
      subLinks: [
        { label: "Student Forms", toRoute: "/forms/studentforms" },
        { label: "Staff Forms", toRoute: "/forms/staffforms" },
        { label: "Admission Process", toRoute: "/forms/admissionprocess" },
      ],
    },
    {
      label: "Reports",
      icon: <TbReportAnalytics size={20} />,
      subLinks: [
        { label: "Excel Reports", toRoute: "/reports/excelreports" },
        { label: "Parent Reports", toRoute: "/reports/parentreports" },
        { label: "Staff Reports", toRoute: "/reports/staffreports" },
      ],
    },
  ];

  return (
    <div className={styles.SideBar}>
      <div className={styles.schoolInfoBox}>
        <img src={SchoolLogo} alt="School Logo" className={styles.logo} />
        <h3>School</h3>
      </div>
      <div className={styles.MenuItemsList}>
        {sideBarMenuItems.map((item) => (
          <SideBarMainLink
            key={item.label}
            data={item}
            expandedLabel={expandedLabel}
            setExpandedLabel={setExpandedLabel}
          />
        ))}
      </div>
    </div>
  );
}

export default SideBar;
